import * as React from "react";
import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const SummaryCard = ({ title, value, icon: Icon, secondaryValue }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        height: "100%",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.12)",
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        transition: "all 0.3s ease",
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.light,
          0.1
        )} 0%, ${alpha(theme.palette.background.paper, 0.8)} 100%)`,
        backdropFilter: "blur(8px)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 25px 0 rgba(0,0,0,0.15)",
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "24px !important",
        }}
      >
        <Box
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            borderRadius: "12px",
            width: 60,
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
            color: theme.palette.primary.contrastText,
            boxShadow: "0 4px 12px 0 rgba(0,0,0,0.1)",
          }}
        >
          <Icon fontSize="medium" />
        </Box>
        <Box>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            gutterBottom
            sx={{ opacity: 0.8 }}
          >
            {title}
          </Typography>
          <Typography
            variant="h4"
            component="div"
            fontWeight="800"
            sx={{
              background: `linear-gradient(135deg, ${
                theme.palette.text.primary
              } 0%, ${alpha(theme.palette.text.primary, 0.8)} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {value}
          </Typography>
          {secondaryValue && (
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ opacity: 0.7 }}
            >
              {secondaryValue}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};